module.exports = __webpack_public_path__ + "img/020024.38f0bdb9.png";